import React from 'react';

import { Button, Card } from 'react-bootstrap';
export const NotesBooksCard = ({ name, attachedDocument, sys }) => {
  return (
    <Card className='text-center' style={{ minHeight: '18rem' }}>
      <Card.Body>
        <Card.Title>{name}</Card.Title>
        <Card.Text>
          <p>Uploaded At</p>
          <p>{new Date(sys.publishedAt).toLocaleString()} PST</p>
        </Card.Text>
        <a rel='noreferrer' target='_blank' href={attachedDocument}>
          <Button className='my-3'>View Here</Button>
        </a>
      </Card.Body>
    </Card>
  );
};
